import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonGotoLogo } from './GotoLogo.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonGotoLogo({ prefix }));
}
